import { useScheduleDimension } from "@/hooks/useScheduleDimension";
import { PANEL_HEIGHT_DIMENSION } from "@/lib/schedulePanelHeights";

export interface SchedulePanelHeight {
  height: number;
  setHeight: (height: number) => void;
  resetHeight: () => void;
}

/**
 * Adjustable height for one of the schedule's stacked panels (schedule
 * window, crew list, client feedback), persisted per briefing and per panel.
 * Falls back to the panel's own default until the producer drags it.
 */
export function useSchedulePanelHeight(
  briefingId: string,
  panel: string,
  defaultHeight: number,
): SchedulePanelHeight {
  const { value, setValue, reset } = useScheduleDimension(
    PANEL_HEIGHT_DIMENSION,
    briefingId,
    panel,
    defaultHeight,
  );
  return { height: value, setHeight: setValue, resetHeight: reset };
}
